import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    startedAt: String,
    durationMinutes: Number,
    stopName: String,
  }

  static targets = ["display", "progress", "icon", "label"]

  connect() {
    this.updateTimer()
    this.interval = setInterval(() => this.updateTimer(), 1000)
  }

  disconnect() {
    if (this.interval) {
      clearInterval(this.interval)
    }
  }

  updateTimer() {
    const startedAt = new Date(this.startedAtValue)
    const totalSeconds = this.durationMinutesValue * 60
    const elapsed = Math.floor((Date.now() - startedAt.getTime()) / 1000)
    const remaining = Math.max(0, totalSeconds - elapsed)

    const mins = Math.floor(remaining / 60)
    const secs = remaining % 60
    const timeStr = `${mins}:${secs.toString().padStart(2, "0")}`

    const progress = totalSeconds > 0 ? remaining / totalSeconds : 0
    const isExpired = remaining <= 0

    if (this.hasDisplayTarget) {
      this.displayTarget.textContent = timeStr
      this.displayTarget.classList.toggle("text-red-400", isExpired)
      this.displayTarget.classList.toggle("text-train-yellow", !isExpired)
    }

    if (this.hasProgressTarget) {
      this.progressTarget.style.width = `${progress * 100}%`
      this.progressTarget.classList.toggle("bg-red-500", isExpired)
      this.progressTarget.classList.toggle("bg-train-yellow", !isExpired)
    }

    if (this.hasIconTarget) {
      // Clear existing children
      while (this.iconTarget.firstChild) {
        this.iconTarget.removeChild(this.iconTarget.firstChild)
      }
      const path = document.createElementNS("http://www.w3.org/2000/svg", "path")
      path.setAttribute("stroke-linecap", "round")
      path.setAttribute("stroke-linejoin", "round")
      path.setAttribute("stroke-width", "2")
      if (isExpired) {
        path.setAttribute(
          "d",
          "M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
        )
      } else {
        path.setAttribute("d", "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z")
      }
      this.iconTarget.appendChild(path)
      this.iconTarget.classList.toggle("text-red-400", isExpired)
      this.iconTarget.classList.toggle("text-train-yellow", !isExpired)
    }

    if (this.hasLabelTarget) {
      this.labelTarget.textContent = isExpired
        ? `Time's up at ${this.stopNameValue}!`
        : this.stopNameValue
    }
  }
}
